// extracted by extract-css-chunks-webpack-plugin
module.exports = {"background":"styles__background__3d2-R","text":"styles__text__VC3oF"};